import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_tile-right-click';
/**
 * Fired when user right clicks anywhere on a product tile (limited to Search and CatNav for now)
Parameters: context (deprecated, see below), requestId, productToken, promotedBy

ImpressionId: BE-generated product impression id
screenContext: ProductTileScreen
containerContext: ProductTileScreenContainer
token: screen specific token e.g. query
*/
export function trackProductTileRightClick(context_string, requestId_string2, productToken, promotedBy_string3, impressionId_string4, screenContext_string5 = '', containerContext_string6 = '', token_string7 = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            context_string,
            requestId_string2,
            productToken,
            promotedBy_string3,
            impressionId_string4,
            screenContext_string5,
            containerContext_string6,
            token_string7,
        },
    });
}
